import { View as NoticeView} from '../../setting/notice/item'
import { moment } from '@/util'

const List = {
  props:['module'],
  data(){
    return {
      loading:false,
      data:[]
    }
  },
  created(){
    this.$watch('module' , function(nv){
      if(nv) this.query()
    },{immediate:true})
  },
  methods:{
    query(){
      let params = {module:this.module , isRead:0}
      this.loading = true
      this.$request.messages(params).then(resp => {
        this.loading = false
        this.data = resp.data || []
      })
    },
    handleClick(data , idx){
      this.data.splice(idx , 1)
      this.$emit('click' , {id:data.id,...JSON.parse(data.extras)})
    }
  },
  render(){
    return (
      <div style="max-height:270px;overflow-y:auto;">
        {
          this.data.length == 0 ? (
            <div style="font-size:14px;color:rgba(0,0,0,.45);padding:45px;text-align:center;">
              <Icon size={60} style="opacity:0.3;" type="ios-megaphone-outline" />
              <p>您已读完所有消息</p>
            </div>
          ): this.data.map((i,idx) => (
            <div style="line-height:1em;padding:12px 24px;" on-click={() => this.handleClick(i , idx)}>
              <div style="font-size:14px;color:rgba(0,0,0,.65);margin-bottom: 8px;font-weight: 400;">{i.message}</div>
              <div style="margin-top: 4px;color:rgba(0,0,0,.45);font-size: 12px;line-height: 1.5;">{moment(i.createDatetime , 'yyyy-MM-dd')}</div>
            </div>
          ))
        }
      </div>
    )             
  }
}

export default {
  data(){
    return {
      state:{
        noticeCount:0
      }
    }
  },
  created(){
    this.query()
  },
  methods:{
    query(){
      this.$request.messageCount().then(resp => {
        this.state.noticeCount = resp.data || 0
      })
    },
    renderContent(){
      return (
        <sl-tabs name="notice" style="width:340px;">
          <sl-tab-pane name="notice" label={`消息 (${this.state.noticeCount})`}>
            <List module={5} on-click={this.handleClick} />
          </sl-tab-pane>
        </sl-tabs>
      )
    },
    handleClick(data){
      this.$request.message(data.id).then( resp => {
        this.query()
      })

      if( data.module == 5){
        this.$dialog({
          width:600,
          paddingless:true,
          render:(h)=>{
            return <NoticeView id={data.params} />
          }
        })
      }
    }
  },
  render(){
    const { state } = this
    const slots = {
      default:() => <Badge count={state.noticeCount} class-name="badge red" overflow-count="99">
          <Icon size="28" type="ios-notifications-outline"></Icon>
        </Badge>,
      list:() => this.renderContent()
    }
    return (
      <Dropdown style="margin:0;" title="消息" trigger="click" placement="bottom-end" scopedSlots={slots}>
        
      </Dropdown>
    )
  }
}